import { orgSchema, breadcrumbSchema } from '../lib/seo'
import SeoHead from '../components/SeoHead'
import ExpertisePage from '../components/expertise/ExpertisePage'
import AdrClassDiamond from '../components/expertise/AdrClassDiamond'
import ExpertiseStatement from '../components/expertise/ExpertiseStatement'
import AdrSplitFlow from '../components/expertise/AdrSplitFlow'
import { useExpertiseContent } from '../components/expertise/useExpertiseContent'
import { useT, useLocale } from '../i18n/LocaleContext'
import { localizedPath } from '../i18n/routes'

/**
 * Expertise — ADR (marchandises dangereuses).
 * Page différenciante : Yaslan stocke & expédie les marchandises dangereuses
 * e-commerce (permis de stockage ADR). Animations bespoke câblées en Task 4.
 */
export default function AdrPage() {
  const { t } = useT()
  const locale = useLocale()
  const content = useExpertiseContent('adrPage')
  const path = localizedPath('expertise.adr', locale)
  const url = `https://yaslan.be${path}`

  return (
    <>
      <SeoHead
        title={t('seo.adr.title')}
        description={t('seo.adr.description')}
        path={path}
        jsonLd={[
          {
            '@type': 'Service',
            '@id': `${url}#service`,
            name: 'Stockage & expédition ADR e-commerce — Yaslan',
            serviceType: 'Logistique de marchandises dangereuses (ADR)',
            description: t('seo.adr.description'),
            provider: { '@id': 'https://yaslan.be/#organization' },
            areaServed: ['Europe', 'United Kingdom', 'Switzerland'],
            url,
          },
          {
            '@type': 'FAQPage',
            '@id': `${url}#faq`,
            inLanguage: locale,
            mainEntity: content.faq.map((f) => ({
              '@type': 'Question',
              name: f.q,
              acceptedAnswer: { '@type': 'Answer', text: f.a },
            })),
          },
          orgSchema(locale),
          breadcrumbSchema([
            { name: t('breadcrumb.home'), path: localizedPath('home', locale) },
            { name: t('breadcrumb.adr'), path },
          ]),
        ]}
      />
      <ExpertisePage
        content={content}
        breadcrumbLabel={t('breadcrumb.adr')}
        heroVisual={
          <AdrClassDiamond
            badge={content.anim.diamond.badge}
            classes={content.anim.diamond.classes}
          />
        }
        scopeVisual={<ExpertiseStatement text={content.scope.statement} />}
        processVisual={
          <AdrSplitFlow
            badge={content.anim.split.badge}
            stored={content.anim.split.stored}
            b2c={content.anim.split.b2c}
            b2cDesc={content.anim.split.b2cDesc}
            b2b={content.anim.split.b2b}
            b2bDesc={content.anim.split.b2bDesc}
            carriers={content.anim.split.carriers}
          />
        }
      />
    </>
  )
}
